import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react"; // import PropTypes from "prop-types";

import classnames from "classnames";
import { Link } from "react-router-dom"; // import config from "react-property-app/config";
// // Components
// import Icon from "react-property-app/components/Icon";
//

import styles from "./CoordMap.module.scss";
import "./CoordMap.scss";
export var CoordMap = function CoordMap(a) {
  var b = a.levels,
      c = a.active,
      d = a.noButtons,
      e = a.onClick,
      f = useState(0),
      g = _slicedToArray(f, 2),
      h = g[0],
      i = g[1],
      j = b[h],
      k = j || {},
      l = k.coords,
      m = void 0 === l ? [] : l,
      n = k.image,
      o = void 0 === n ? {} : n,
      p = k.link,
      q = k.activePolygon,
      r = k.legend,
      s = void 0 === r ? [] : r,
      t = m.map(function (a) {
    // if (typeof coord === "object") return coord.coord;
    return a;
  }),
      u = function u(a) {
    var b = h - 1;
    i(0 >= b ? 0 : b), "function" == typeof e && e(a);
  },
      v = o.width || 1440,
      w = o.height || 972;

  return d = d || 0 === h && h === b.length - 1, /*#__PURE__*/React.createElement("div", {
    className: styles.coordMap
  }, d ? null : /*#__PURE__*/React.createElement("div", {
    className: styles.zoom
  }, /*#__PURE__*/React.createElement("button", {
    onClick: u,
    disabled: 0 === h
  }, "+"), /*#__PURE__*/React.createElement("button", {
    onClick: function zoomOut() {
      var a = h + 1;
      i(a >= b.length - 1 ? b.length - 1 : a);
    },
    disabled: h === b.length - 1
  }, "-")), b.map(function (a, b) {
    var c = a.image && a.image.url;
    return c ? /*#__PURE__*/React.createElement("img", {
      src: c,
      className: classnames("levelimg", {
        active: b === h
      }, {
        parent: 0 === b
      }),
      title: "Plan",
      width: "100%",
      alt: "plan",
      key: a + b
    }) : null;
  }), s.length ? /*#__PURE__*/React.createElement("div", {
    className: "legend"
  }, s.map(function (a, b) {
    var c = a.label,
        d = a.className;
    return /*#__PURE__*/React.createElement("span", {
      key: "legend-".concat(b),
      className: "legend__".concat(d || c.toLowerCase())
    }, c);
  })) : null, t.length ? /*#__PURE__*/React.createElement("svg", {
    viewBox: "0,0,".concat(v, ",").concat(w)
  }, t.map(function (a) {
    var b = a.name,
        d = a.coords,
        e = a.status_id || a.status,
        f = "function" == typeof p ? p(a) : p || "",
        g = classnames(_defineProperty({}, styles.active, c === a.slug || q === a.slug)),
        h = function h(b) {
      return f ? /*#__PURE__*/React.createElement(Link, {
        to: f,
        className: g
      }, /*#__PURE__*/React.createElement("polygon", b)) : /*#__PURE__*/React.createElement("polygon", Object.assign({}, b, {
        onClick: function onClick() {
          return u(a);
        }
      }));
    };

    return 1 === e ? /*#__PURE__*/React.createElement(h, {
      key: f + b,
      points: d,
      alt: b
    }) : 2 === e ? /*#__PURE__*/React.createElement(h, {
      key: f + b,
      points: d,
      alt: b,
      className: styles.sold
    }) : /*#__PURE__*/React.createElement(h, {
      key: f + b,
      points: d,
      alt: b,
      className: styles.builder
    });
  })) : null);
}; // const coordMapLevels = [
// {
//   title: "Floor Plates",
//   navigation: [],
//   coords: [],
//   image: ''
// }
// ];

export default CoordMap;